module.exports = __webpack_public_path__ + "img/p1.32d66d4b.png";